import { Shadow, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing } from '@genial/design-tokens';
import { ResponsesPortfolioResponse } from '@genial/services/dist/models';
import React from 'react';

import { LateralBar } from '../../../../../../../NewApplication/Product/components/LateralBar';

import { Header } from './components/Header';
import { MovementationDetails } from './components/MovementationDetails';
import { PositionDetailsTable } from './components/PositionDetailsTable';
import { messageError } from './constants';

interface FundItemProps {
  data: ResponsesPortfolioResponse;
}

export const FundItem: React.FC<FundItemProps> = ({ data }) => {
  const title = data?.portfolioName || messageError;

  return (
    <Shadow
      marginBottom={Spacing['inset.nano']}
      level={3}
      borderRadius={BoxRadius.sm}
      my={Spacing['inline.nano']}>
      <VStack borderRadius={BoxRadius.sm}>
        <LateralBar
          backgroundColor={Color['product.fundos']}
          borderTopLeftRadius={BoxRadius.sm}
          borderBottomLeftRadius={BoxRadius.sm}
        />
        <VStack p={Spacing['inline.xxxs']} space={Spacing['inline.xxxs']}>
          <Header title={title} />
          <PositionDetailsTable data={data?.funds || []} />
          <MovementationDetails data={data?.funds || []} />
        </VStack>
      </VStack>
    </Shadow>
  );
};
